export default __webpack_public_path__ + "static/media/logo-slack.7c47c5aa.svg";